var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1006 -394)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "transparent",
    width: 160,
    height: 160,
    transform: "translate(1006 394)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(868 396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.782,195.074v17.554a.614.614,0,0,1-.612.612h-.436v91.445a9.542,9.542,0,0,1-9.541,9.541h-57.14a9.539,9.539,0,0,1-9.539-9.541V216.448H422.2a.432.432,0,0,1-.433-.43v-9.99a.433.433,0,0,1,.433-.433h.315v-3.763H422.2a.453.453,0,0,1-.452-.454v-9.854a.453.453,0,0,1,.452-.452h.318v-5.137h-.323a.4.4,0,0,1-.4-.4v-5.377a.4.4,0,0,1,.4-.4h.323V168.863a9.539,9.539,0,0,1,9.538-9.539h57.139a9.541,9.541,0,0,1,9.541,9.539v25.6h.436A.614.614,0,0,1,499.782,195.074Z",
    transform: "translate(-247.075 -159.325)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e6e8ec",
    width: 10.643,
    height: 2.161,
    rx: 1.081,
    transform: "translate(206.337 4.893)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#e6e8ec",
    cx: 1.226,
    cy: 1.226,
    r: 1.226,
    transform: "translate(218.589 4.748)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M509.563,185.479V320.206a6.054,6.054,0,0,1-6.054,6.051h-54.7a6.036,6.036,0,0,1-2.8-.682,5.648,5.648,0,0,1-.588-.347,6.058,6.058,0,0,1-2.67-5.022V185.479a6.053,6.053,0,0,1,6.054-6.054H457v1.05a4.985,4.985,0,0,0,4.984,4.985H489.8a4.985,4.985,0,0,0,4.985-4.985v-1.05h8.724A6.052,6.052,0,0,1,509.563,185.479Z",
    transform: "translate(-262.343 -174.053)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc9c9",
    d: "M710.519,420.725v7.792s.623,8.727,4.052,13.09c0,0,5.61,7.947,6.389,6.233L720,442.2l-3.248-3.083-1.714-9.662-.467-8.727Z",
    transform: "translate(-458.669 -350.861)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc9c9",
    d: "M666.308,524.941v5.766l-4.675,1.714v-6.7Z",
    transform: "translate(-380.019 -384.642)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc9c9",
    d: "M637.577,522.609l3.117,7.012-4.363,1.87-.935-6.856Z",
    transform: "translate(-360.794 -382.933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.286,468.954s6.233,56.255,3.9,56.411-6.857,3.117-6.857,1.091-3.584-28.361-3.584-28.361l-3.428-13.557v18.7L759.9,524.43s-3.428,4.519-5.922,1.87l-5.3-20.726s-7.012-31.478-6.7-33.971C741.977,471.6,758.027,457.89,766.286,468.954Z",
    transform: "translate(-481.712 -383.04)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.888,702.859a2.638,2.638,0,0,1,4.052-.935l2.337,2.8s6.026,4.991,1.75,6.06c-4.408,1.1-7.048-.07-7.048-.07a3.407,3.407,0,0,0-1.4-.468,3.394,3.394,0,0,1-2.026-1.4c0-.312.468-5.834.468-5.834a.983.983,0,0,1,1.091.156C821.576,703.638,821.888,702.859,821.888,702.859Z",
    transform: "translate(-538.56 -556.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.924,700.9s2.961-2.338,4.363.312c0,0,.883.312.987,0s.883-.467.883,1.247.846,5.99.067,6.145-1.558.623-1.4,1.247-.846.711-4.43.555-3.74-1.558-3.74-1.558a5.638,5.638,0,0,1,.935-3.117A25.279,25.279,0,0,0,784.924,700.9Z",
    transform: "translate(-510.791 -555.454)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc9c9",
    d: "M747.553,321.605s-.779,5.766,4.207,7.792-11.064,8.727-12.622,4.831.312-5.142.312-5.142,1.558-1.558.156-5.766Z",
    transform: "translate(-479.185 -278.233)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffc9c9",
    cx: 6.857,
    cy: 6.857,
    r: 6.857,
    transform: "translate(256.525 33.711)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M746.231,357.755s-4.675,2.493-9.194.623-4.363,6.233-4.363,6.233l2.337,6.077,16.207-1.558-1.091-9.35Z",
    transform: "translate(-474.902 -304.721)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1877f2",
    d: "M725.966,337.8a5.657,5.657,0,0,1,3.881,2.995l7.48,2.337,1.87,2.649-2.182,19.167s4.052,3.9,4.052,6.077,4.987,9.662,2.493,8.727-7.012-4.207-7.012-4.207-11.376.468-14.96,3.584-4.987,2.182-4.987,2.182-3.74-16.206-3.9-18.7-4.519-17.453-4.519-17.453l7.792-4.363,1.985-2.252,5.5,8.8,4.987-6.077S725.981,339.329,725.966,337.8Z",
    transform: "translate(-456.961 -290.103)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc9c9",
    d: "M820.144,412.562l.935,4.987s4.207,15.583,3.584,20.881c0,0,.467,11.843-2.182,10.441s-1.247-9.973-1.247-9.973l-3.74-15.427-2.026-9.038Z",
    transform: "translate(-535.57 -344.88)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1877f2",
    d: "M814.539,364.168l1.558.935s5.922,12.311,4.519,13.246-7.48,2.961-7.48,2.961Z",
    transform: "translate(-533.861 -309.42)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1877f2",
    d: "M549.541,205.8l-3.662-.078-.857,1.48,1.091,15.116,5.61,1.247Z",
    transform: "translate(-294.575 -150.736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.1,278.48l1.236-.449a8.788,8.788,0,0,0-6.179-2.359l1.011-1.011a4.587,4.587,0,0,0-4.719,1.461,20.073,20.073,0,0,0-3.4,4.34h-1.323l.552,1.1-1.933,1.1,1.984-.2a5.574,5.574,0,0,0,.188,2.861l.449,1.236a35.638,35.638,0,0,0,1.8-4.045v1.123S725,282.637,725,281.963l.674.786.337-1.236,4.157,1.236-.674-1.011,2.584.337-1.011-1.236s2.921,1.461,3.034,2.7a10.425,10.425,0,0,0,.884,2.847l.935-1.091S737.361,280.165,734.1,278.48Z",
    transform: "translate(-465.138 -243.711)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ffb8b8",
    cx: 0.545,
    cy: 1.402,
    rx: 0.545,
    ry: 1.402,
    transform: "translate(268.602 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.2,669.32c3.322,6.16,10.372,8.8,10.372,8.8s1.664-7.343-1.657-13.5-10.372-8.8-10.372-8.8S192.875,663.16,196.2,669.32Z",
    transform: "translate(-27.07 -523.121)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1877f2",
    d: "M173.661,691.834c6,3.608,8.307,10.775,8.307,10.775s-7.413,1.317-13.411-2.291-8.307-10.775-8.307-10.775S167.663,688.226,173.661,691.834Z",
    transform: "translate(0.75 -547.661)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 2.94,
    cy: 2.94,
    r: 2.94,
    transform: "translate(210.819 144.772)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.384 54.79)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#1877f2",
    width: 37.417,
    height: 37.417,
    rx: 18.709
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.989,19.956H0V0H4.989Zm4.989,0v-4.32c.146-.018.293-.042.436-.072a5.671,5.671,0,0,0,2.039-.858A5.719,5.719,0,0,0,14.519,12.2a5.674,5.674,0,0,0,.332-1.07,5.758,5.758,0,0,0,0-2.3,5.669,5.669,0,0,0-.858-2.039,5.719,5.719,0,0,0-2.509-2.066,5.675,5.675,0,0,0-1.07-.332c-.143-.029-.29-.053-.436-.072V0A10.138,10.138,0,0,1,11,.051,9.988,9.988,0,0,1,11.989.2c.322.066.643.149.956.246s.618.209.917.336.589.266.872.42.558.321.823.5.522.371.768.574.484.419.709.644.442.463.644.709.4.5.574.768.347.542.5.823.295.576.42.872.239.607.335.917.18.635.246.956a10,10,0,0,1,.151.991,10.127,10.127,0,0,1,0,2.04,10.006,10.006,0,0,1-.151.991c-.066.322-.149.643-.246.956s-.209.618-.335.917-.267.59-.42.872-.321.558-.5.823-.372.522-.574.768-.419.484-.644.709-.463.442-.709.644-.5.4-.768.574-.542.347-.823.5-.577.3-.872.42-.607.239-.917.336-.635.18-.956.246A10,10,0,0,1,11,19.9,10.13,10.13,0,0,1,9.978,19.956Z",
    transform: "translate(28.687 9.978) rotate(90)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivation);
export default __webpack_public_path__ + "static/media/Activation.c6f0223dfb7fe9fd0b572f8c1a4a2310.svg";
export { ForwardRef as ReactComponent };